

import { Checkbox, FormControlLabel, Grid, ListItem, Tab, Tabs, TextField, Typography } from '@mui/material';

import { Stack } from '@mui/system';

import { DataGridPro, GridColDef, GridRenderEditCellParams, GridRowsProp } from '@mui/x-data-grid-pro';

import { LabelItem, LabelItemType, labelEditorSlice } from 'cdx-common';

import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { RootState, appStore } from 'store';



/**

 * Composante qui permet de présenter le contenu d'une feuille de données.

 * 

 * Fonctionnalités : 

 *  - Être en mesure de spécifier l'emplacement de départ de la source de données

 *  - Être en mesure de spécifier les en-tête de colonne ou non

 *  - Être en mesure d'indiquer au composant parent qu'une source de donnée colonne

 *      a été sélectionné ou déplacé (StartDrag). Déterminer ou doit se gérer le drag and drop...

 * 

 * @returns component

 */







export const LabelerSheet = () => {



    const dataSheet = useSelector((state: RootState) => state.labelEditor.dataSheet);



    const [rowsAndColumns, setRowsAndColumns] = useState<{ rows: GridRowsProp, columns: GridColDef<any>[]; }>({ rows: [], columns: [] });

    const currentSheetIndex = useSelector((state: RootState) => state.labelEditor.currentSheetIndex);

    const currentSheet = useSelector((state: RootState) => state.labelEditor.currentSheet);

    const [alteredSheet, setAlteredSheet] = React.useState<GridRowsProp | undefined>();

    const forceDataGridUpdate = useSelector((state: RootState) => state.labelEditor.forceDataGridUpdate);





    React.useEffect(() => {

        localStorage.setItem('currentSheet', JSON.stringify(currentSheet));

    }, [currentSheet]);



    React.useEffect(() => {

        void setData();

    }, []);



    React.useEffect(() => {



        if (forceDataGridUpdate) {

            void setData();

        }

    }, [forceDataGridUpdate]);



    const renderEditCell = (params: GridRenderEditCellParams<any>) => {

        return <TextField

            variant="outlined"

            size="small"

            value={params.value}

            fullWidth

            autoFocus

            onChange={(e) => {

                // Update the value in the cell

                const updatedValue = e.target.value;

                params.api.setEditCellValue({

                    id: params.id,

                    field: params.field,

                    value: updatedValue,

                });

            }}

        />;

    };



    useEffect(() => {

        if (alteredSheet) {

            appStore.dispatch(labelEditorSlice.actions.setData({

                ...currentSheet,

                values: alteredSheet?.map(p => {

                    const { id, ...rest } = p;

                    return Object.values(rest) as (string | number)[];

                }) ?? []

            }));

        }

    }, [alteredSheet]);



    const setData = () => {

        const values = [...currentSheet.values];



        const columns: GridColDef<any>[] = currentSheet.columns.map((cell, index) => {

            return {



                type: 'singleSelect',

                field: index + '',

                renderHeader: () => {

                    return cell;

                },

                renderEditCell,

                width: 150,

                editable: true,

                sortable: false

            };

        });

        if (columns) {

            setRowsAndColumns({

                rows: values.map((p, index) => {

                    return { ...p, id: index + '' };

                }),

                columns: columns

            });

        } else {

            setRowsAndColumns({ rows: [], columns: [] });

        }

    };



    const setCurrentSheet = (index: number) => {

        appStore.dispatch(labelEditorSlice.actions.setCurrentSheet(index));

    };



    const customColumnMenu = (props: any) => {

        props.colDef.field;

        return (

            <React.Fragment>

                <Stack px={0.5} py={0.5}>

                    {props.labelItems.filter((p: LabelItem) => p.type == LabelItemType.DYNAMIC_TEXT).map((p: LabelItem, index: number) => <ListItem key={index}>{p.value}</ListItem>)}

                </Stack>

            </React.Fragment>

        );

    };



    return <Grid container spacing={1}>

        <Grid item xs={12}>

            <Typography variant='body1'><FormControlLabel control={<Checkbox checked={!!currentSheet.firstRowIsHeader} onChange={() => {

                appStore.dispatch(labelEditorSlice.actions.toggleFirstRowIsHeader());

            }} />} label="La première ligne, c'est l'en-tête de colonne !!" /></Typography>

        </Grid>

        <Grid item xs={12}>

            <Typography variant='h5'>{currentSheet.fileName} {dataSheet ? null : '(copie locale)'}</Typography>

            {dataSheet && dataSheet.sheets.length > 1 ? <Tabs

                value={currentSheetIndex}

                variant='scrollable'

                scrollButtons='auto'>

                {dataSheet.sheets.map((sheet, index) => {

                    return <Tab key={index} value={index} label={sheet.tabName} wrapped onClick={() => {

                        setCurrentSheet(index);

                    }} />;

                })}

            </Tabs> : null}

            <div style={{ height: 400, width: '100%', overflow: 'hidden' }}>

                <DataGridPro

                    density='compact'

                    slots={{

                        columnMenu: customColumnMenu

                    }}

                    rows={rowsAndColumns.rows}

                    columns={rowsAndColumns.columns}

                    initialState={{

                        pagination: {

                            paginationModel: {

                                pageSize: 5,

                            },

                        },

                    }}

                    processRowUpdate={(updatedRow) => {

                        const before: GridRowsProp = alteredSheet ?? { ...rowsAndColumns.rows };

                        setAlteredSheet(Object.values(before).map(p => p.id === updatedRow.id ? { ...updatedRow } : p));

                        return updatedRow;

                    }}

                    onProcessRowUpdateError={(_error) => {



                    }}

                />

            </div>

        </Grid>

    </Grid>;

};
